var IntroSwiper = function (el, duration, type) {
    var is_id = Math.round(Math.random() * 1000000);
    var tid = 0;
    var ltime = 0;
    var tleft = 0;
    var $this = this;
    var active = true;
    var single_intro = $('.c-intro-section').hasClass('single-intro');

    var titles = [];
    var tmo = 0;

    this.touching = false;
    this.changed = false;

    this.duration = parseInt(duration) || 10;
    this.type = parseInt(type) || 0;
    //console.log(is_id);
    this.el = el;
    this.prev = 1;

    this.swiper = new Swiper(this.el, {
        slidesPerView: 1,
        spaceBetween: 0,
        watchOverflow: true,
        watchSlidesProgress: true,
        watchSlidesVisibility: true,
        //loop: single_intro ? false : true,
        loop: false,
        speed: 1000,
        /* effect: 'fade',
        fadeEffect: {
            crossFade: true
        }, */
        threshold: 10,
        on: {
            init: function (sw) {
                titles.forEach(function (val, aid) {
                    val.revert();
                });
                title = [];
                $(".c-intro-section__title").each(function (id, el) {
                    titles.push(new SplitText(el, {type: "lines, words, chars", linesClass: "t-line", wordsClass: "t-word", charsClass: "t-char"}));
                    var dl = id==1?0:1;
                    var dc = 0.025;
                    var td = 0.2;
                    $(el).find(".t-line").each(function (id2, el2) {
                        $(el2).find(".t-char").each(function (id3, el3) {
                            $(el3).css("--t-delay", `${dl.toFixed(2)}s`);
                            $(el3).css("--t-duration", `${td.toFixed(2)}s`);
                            dl += dc;
                            td += 0.01;
                            dc += 0.001;
                        });
                        dl -= dc * 4;
                    });

                    if(id == 1){
                        setTimeout( function(){
                            dl = 1;
                            dc = 0.025;
                            td = 0.2;
                            $(el).find(".t-line").each(function (id2, el2) {
                                $(el2).find(".t-char").each(function (id3, el3) {
                                    $(el3).css("--t-delay", `${dl.toFixed(2)}s`);
                                    $(el3).css("--t-duration", `${td.toFixed(2)}s`);
                                    dl += dc;
                                    td += 0.01;
                                    dc += 0.001;
                                });
                                dl -= dc * 4;
                            });
                        }, 4500);
                    }
                });

                /* $($this.el).find("futurevideo").each(function (index, element) {
                    // element == this
                    let vel = $(element);
                    let src = vel.attr("src");
                    //vel.replaceWith(`<video muted autoplay="autoplay" loop playsinline><source src="${src}" type="video/mp4"></video>`);
                    vel.replaceWith(`<video muted loop playsinline><source src="${src}" type="video/mp4"></video>`);
                }); */
                var avid = $(sw.slides[sw.activeIndex]).find("video");
                /* $($this.el).find("video").each(function (index, element) {
                    element.pause();
                }); */
                if(avid.length > 0){
                    var vd = avid.get(0);
                    vd.currentTime = 0;
                    vd.play();
                }
            },
            resize: function (sw) {
                titles.forEach(function (val, aid) {
                    val.revert();
                });
                title = [];
                $(".c-intro-section__title").each(function (id, el) {
                    titles.push(new SplitText(el, {type: "lines, words, chars", linesClass: "t-line", wordsClass: "t-word", charsClass: "t-char"}));
                    var dl = 1;
                    var dc = 0.025;
                    var td = 0.2;
                    $(el).find(".t-line").each(function (id2, el2) {
                        $(el2).find(".t-char").each(function (id3, el3) {
                            $(el3).css("--t-delay", `${dl.toFixed(2)}s`);
                            $(el3).css("--t-duration", `${td.toFixed(2)}s`);
                            dl += dc;
                            td += 0.01;
                            dc += 0.001;
                        });
                        dl -= dc * 4;
                    });
                });
            },
            slideChange: function(sw){
                //console.log("slidechange fired", sw.activeIndex, sw.realIndex, sw.previousIndex, sw.slides.length);
                
                
                /* let total = sw.slides.length;
                let cur = sw.activeIndex;
                let prev = $this.prev;
                $this.prev = cur;
                let c = 100;

                if(prev == 0) c = total - 2;
                if(prev == 1) c = total - 1;
                if(prev == total - 2) c = 0;
                if(prev == total - 1) c = 1;

                var psl = $(sw.slides[prev]).find("video").get(0);
                if(psl && c < 100){
                    let nv = $(sw.slides[c]).find("video").get(0);
                    if(nv){
                        nv.play();
                        nv.currentTime = psl.currentTime;
                    }
                } */
                //var avid = $(sw.slides[sw.activeIndex]).find("video");
                $($this.el).find("video").each(function (index, element) {
                    element.pause();
                });
                /* if(avid.length > 0){
                    var vd = avid.get(0);
                    vd.currentTime = 0;
                    vd.play();
                } */
                

                //swiper-slide-visible swiper-slide-active
                if($this.touching) $this.changed = true;
            },
            /* beforeSlideChangeStart: function(sw){
                console.log("before start");
            },
            slideChangeTransitionStart: function(sw){
                console.log("slide start fired");
            }, */
            slideChangeTransitionEnd: function(sw){
                //console.log("slide end fired", sw.activeIndex, sw.realIndex);
                $($this.el).find(".swiper-slide:not(.swiper-slide-active) video").each(function (index, element) {
                    element.currentTime = 0;
                });
                $($this.el).find(".swiper-slide-active video").each(function (index, element) {
                    //console.log(element);
                    element.play();
                });
            },
            touchMove: function(sw,ev){
                //console.log("Touch MOVE");
                if(!$this.touching){
                    $($this.el).find("video").each(function (index, element) {
                        element.pause();
                    });
                }
                $this.touching = true;
            },
            touchEnd: function(sw,ev){
                //console.log("Touch END");
                //if($this.touching && $this.changed){
                    var avid = $(sw.slides[sw.activeIndex]).find("video");
                    if(avid.length > 0){
                        var vd = avid.get(0);
                        vd.play();
                    }
                //}
                $this.touching = false;
                $this.changed = false;
            }
        },
        pagination: {
            el: ".swiper-clock-paginator",
            type: "custom",
            renderCustom: function (swiper, current, total) {
                //console.log(current, total);
                clearTimeout(tid);
                var txt = "";
                var i = 0;
                for (i = 0; i < total; i++) {
                    if (i == current - 1) {
                        txt += '<div class="sc-digit sc-icon is-prog-' + is_id + '"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" width="40" height="40">' +
                            '<path class="sc-pause" d="M13 12h3v10h-3zM18 12h3v10h-3z" fill="#fff"/>' +
                            '<path class="sc-play" d="M14 22V12l8 5z" fill="#fff"/>' +
                            '<circle class="sc-prog-bg" cx="20" cy="20" r="16" fill="none" stroke="#8bceeb" stroke-miterlimit="40" stroke-width="8" />' +
                            '<circle class="sc-prog" cx="20" cy="20" r="16" fill="none" stroke="#0094d4" stroke-miterlimit="40" stroke-width="8" style="animation-duration: ' + $this.duration + 's"/>' +
                            '</svg></div>';
                    } else {
                        txt += '<div class="sc-digit is-click-' + is_id + '" data-slide="' + i + '"></div>';
                    }
                }
                ltime = performance.now();
                tleft = $this.duration * 1000;
                tid = setTimeout(function () {
                    var ai = swiper.activeIndex+1;
                    if(ai == swiper.slides.length) ai = 0;
                    //swiper.slideNext();
                    swiper.slideTo(ai);
                }, tleft);
                return txt;
            }
        },

    });

    if ($this.type == 1) {
        if (isMobile()) {
            pause();
            active = false;
        }

        window.addEventListener("resize", function () {
            var m = isMobile();
            if (m && active) {
                pause();
                active = false;
            } else if (!m && !active) {
                restart();
                active = true;
            }
        });
    } else if ($this.type == 2) {
        if (!isMobile()) {
            pause();
            active = false;
        }

        window.addEventListener("resize", function () {
            var m = isMobile();
            if (!m && active) {
                pause();
                active = false;
            } else if (m && !active) {
                restart();
                active = true;
            }
        });
    }


    $(document).on("click", ".is-click-" + is_id, function (e) {
        var id = parseInt($(this).data("slide"));
        $this.swiper.slideToLoop(id);

        e.preventDefault();
        e.stopPropagation();
    });

    $(document).on("click", ".is-prog-" + is_id, function (e) {
        $(this).toggleClass("sc-paused");
        if ($(this).hasClass("sc-paused")) {
            clearTimeout(tid);
            var dt = Math.round(performance.now() - ltime);
            tleft -= dt;
            if (tleft < 0) tleft = 1;
        } else {
            clearTimeout(tid);
            ltime = performance.now();
            tid = setTimeout(function () {
                //$this.swiper.slideNext();
                var ai = $this.swiper.activeIndex+1;
                if(ai == $this.swiper.slides.length) ai = 0;
                $this.swiper.slideTo(ai);
            }, tleft);
        }

        e.preventDefault();
        e.stopPropagation();
    });

    $(document).on("visibilitychange", function (e) {
        //console.log("VISIBILITY");
        //console.log(document.hidden?"hidden":"visible");
        if (document.hidden) {
            pause();
        } else {
            restart();
        }
    });

    function pause() {
        //console.log("pause")
        clearTimeout(tid);
        $(".is-prog-" + is_id).addClass("sc-paused");
        var dt = Math.round(performance.now() - ltime);
        tleft -= dt;
        if (tleft < 0) tleft = 1;
    }

    function play() {
        //console.log("play")
        clearTimeout(tid);
        ltime = performance.now();
        tid = setTimeout(function () {
            //$this.swiper.slideNext();
            var ai = $this.swiper.activeIndex+1;
            if(ai == $this.swiper.slides.length) ai = 0;
            $this.swiper.slideTo(ai);
        }, tleft);
    }

    function restart() {
        console.log("restart");
        clearTimeout(tid);
        $(".is-prog-" + is_id).removeClass("sc-paused").removeClass("sc-icon");
        setTimeout(function () {
            $(".is-prog-" + is_id).addClass("sc-icon");
        }, 1);
        ltime = performance.now();
        tleft = $this.duration * 1000;
        tid = setTimeout(function () {
            //$this.swiper.slideNext();
            var ai = $this.swiper.activeIndex+1;
            if(ai == $this.swiper.slides.length) ai = 0;
            $this.swiper.slideTo(ai);
        }, tleft);
    }

    function isMobile() {
        return window.innerWidth < 768;
    }
};

var headerSC = [];
var deskSC = [];
var mobileSC = [];

$(window).on("load", function () {
    $(".swiper-clock-header").each(function (index, element) {
        // element == this
        headerSC.push(new IntroSwiper(element));
    });
    $(".swiper-clock-inline.h-mobile-hide").each(function (index, element) {
        // element == this
        //console.log(element);
        deskSC.push(new IntroSwiper(element, 6, 1));
    });
    $(".swiper-clock-inline.h-mobile-show").each(function (index, element) {
        // element == this
        //console.log(element);
        mobileSC.push(new IntroSwiper(element, 6, 2));
    });
});
